import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

const dummyAttendanceRecords = [
  { id: 1, date: new Date(Date.now() - 86400000 * 3).toLocaleDateString(), clock_in: new Date(Date.now() - 86400000 * 3).setHours(9, 0, 0), clock_out: new Date(Date.now() - 86400000 * 3).setHours(17, 30, 0), status: 'Present' },
  { id: 2, date: new Date(Date.now() - 86400000 * 2).toLocaleDateString(), clock_in: new Date(Date.now() - 86400000 * 2).setHours(8, 45, 0), clock_out: new Date(Date.now() - 86400000 * 2).setHours(17, 0, 0), status: 'Present' },
  { id: 3, date: new Date(Date.now() - 86400000 * 1).toLocaleDateString(), clock_in: new Date(Date.now() - 86400000 * 1).setHours(9, 15, 0), clock_out: new Date(Date.now() - 86400000 * 1).setHours(18, 0, 0), status: 'Late' },
];

export const fetchAttendance = createAsyncThunk('attendance/fetchAll', async (_, { rejectWithValue }) => {
  await delay(500);
  return dummyAttendanceRecords;
});

export const clockIn = createAsyncThunk('attendance/clockIn', async (_, { rejectWithValue, getState }) => {
  await delay(400);
  const state = getState().attendance;
  const today = new Date().toLocaleDateString();
  
  if (state.records.some(r => r.date === today && r.clock_in)) {
    return rejectWithValue({ error: 'Already clocked in today.' });
  }

  return {
    id: Math.random(),
    date: today,
    clock_in: new Date().toISOString(),
    clock_out: null
  };
});

export const clockOut = createAsyncThunk('attendance/clockOut', async (_, { rejectWithValue, getState }) => {
  await delay(400);
  const state = getState().attendance;
  const today = new Date().toLocaleDateString();
  
  const existingRecord = state.records.find(r => r.date === today);
  
  if (!existingRecord) {
    return rejectWithValue({ error: 'No clock in record found for today.' });
  }
  if (existingRecord.clock_out) {
    return rejectWithValue({ error: 'Already clocked out today.' });
  }

  return {
    ...existingRecord,
    clock_out: new Date().toISOString()
  };
});

const attendanceSlice = createSlice({
  name: 'attendance',
  initialState: {
    records: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAttendance.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAttendance.fulfilled, (state, action) => {
        state.loading = false;
        // Only initialize if empty so we don't overwrite local records during session
        if (state.records.length === 0) {
          state.records = action.payload;
        }
      })
      .addCase(fetchAttendance.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(clockIn.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(clockIn.fulfilled, (state, action) => {
        state.loading = false;
        state.records.push(action.payload);
      })
      .addCase(clockIn.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(clockOut.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(clockOut.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.records.findIndex(r => r.id === action.payload.id);
        if (index !== -1) {
          state.records[index] = action.payload;
        }
      })
      .addCase(clockOut.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default attendanceSlice.reducer;
